<template>
  <div id="cont-segui">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text>
          <titulo-bar titulo="Seguimiento de Observaciones">
            <template v-slot:opciones-derecha>
              <v-btn
                v-show="true"
                text
                rounded
                class="text-capitalize"
                :to="{ name: 'auditoriasTablero' }"
              >
                <v-icon left color="primary">
                  mdi-chart-gantt
                </v-icon>
                Tablero
              </v-btn>
              <v-menu
                v-model="mostrarMenuExportar"
                :close-on-content-click="false"
                offset-y>
                  <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                      v-on="{ ...onMenu, ...onTooltip }">
                    <v-icon> mdi-export-variant </v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <ExcelObservacionesAuditoriasEtiquetas
                  v-if="!$apollo.queries.auditoriasInformesObservacionesDetalles.loading"
                  :etiquetasConDesgloses="getDetallesPorEtiqueta"
                  listItem/>
                </v-list>
              </v-menu>
            </template>
          </titulo-bar>
          <filtros :filtros="filtros"> </filtros>
        </v-card-text>
      </v-card>
      <template v-if="$apollo.queries.auditoriasInformesObservacionesDetalles.loading">
        <v-skeleton-loader type="table-heading, table-thead, table-tbody"></v-skeleton-loader>
      </template>
      <template v-else>
        <v-simple-table class="pa-3">
          <template v-slot:default>
            <thead>
              <tr>
                <template v-for="header in getHeaders">
                  <template>
                    <th :key="header.id">
                      {{ header.text }}
                    </th>
                  </template>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="detalle in getListadoDetalles">
                <template>
                  <tr :key="detalle.id" class="body-1">
                    <td>
                      <v-chip
                        dark
                        small
                        outlined
                        :color="getColorFechaVencimiento(detalle.fechaVencimiento)"
                      >
                      <v-icon left small>
                        {{ getIconFechaVencimiento(detalle.fechaVencimiento) }}
                      </v-icon>
                        {{ detalle.fechaVencimiento }}
                      </v-chip>
                    </td>
                    <td>
                      <div class="my-1">
                        <strong>
                          {{
                            detalle.auditoriaObservacion.auditoriaInforme.auditoria.enteFiscalizador
                              .descripcion
                          }}
                        </strong>
                      </div>
                      <div>
                        {{ detalle.auditoriaObservacion.auditoriaInforme.auditoria.nombre }}
                      </div>
                      <div v-if="showTags">
                        <template v-for="etiqueta in detalle.etiquetas">
                          <template>
                            <v-chip
                              :key="etiqueta.id"
                              x-small
                              class="mr-2 mb-1"
                              :color="etiqueta.auditoriaEtiqueta.color"
                              :dark="etiqueta.auditoriaEtiqueta.esTextoClaro"
                            >
                              {{ etiqueta.auditoriaEtiqueta.descripcion }}
                            </v-chip>
                          </template>
                        </template>
                      </div>
                    </td>
                    <td>
                      {{ detalle.auditoriaObservacion.auditoriaInforme.nombre }}
                    </td>
                    <td>
                      <v-row no-gutters class="rounded-lg grey lighten-5 pa-1 mb-1 mt-1">
                        <v-col cols="2">
                          <v-badge inline :content="detalle.auditoriaObservacion.numero"> </v-badge>
                        </v-col>
                        <v-col cols="10">
                          {{ detalle.auditoriaObservacion.descripcion }}
                          <v-chip x-small
                            :color="getColorStatus(detalle.auditoriaObservacion.estatus)" dark>
                              {{ detalle.auditoriaObservacion.estatus }}
                            <v-icon right x-small
                              v-if="detalle.auditoriaObservacion.estatus === 'SOLVENTADA'">
                              mdi-check
                            </v-icon>
                          </v-chip>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="my-2">
                        <v-tooltip top v-if="mixValidaScopesActions(2)" allow-overflow
                          max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              rounded
                              outlined
                              class="text-capitalize"
                              @click="detalle.auditoriaObservacion.comentarios !== ''
                                ? botonEditarObservacionComentario(detalle)
                                : botonEditarObservacionComentario(detalle)">
                              <v-icon small>
                                {{ detalle.auditoriaObservacion.comentarios !== ''
                                ? 'mdi-comment-text-outline'
                                : 'mdi-comment-plus-outline' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ detalle.auditoriaObservacion.comentarios !== ''
                              ? detalle.auditoriaObservacion.comentarios
                              : 'Agregar comentario a la observación' }}
                          </span>
                        </v-tooltip>
                      </v-row>
                    </td>
                    <td>
                      <div class="mb-1 mt-1" v-if="detalle.contrato">
                        <v-btn
                          class="text-capitalize"
                          color="info"
                          plain
                          small
                          @click="detallesContrato(detalle.contrato.id)"
                        >
                          {{ detalle.contrato.numero }}
                        </v-btn>
                      </div>
                      <div>
                        {{ detalle.texto }}
                      </div>
                      <div>
                        <v-tooltip top v-if="mixValidaScopesActions(2)" allow-overflow
                        max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="text-capitalize my-2"
                              small
                              rounded
                              outlined
                              @click="detalle.comentarios !== '' && detalle.comentarios !== null
                                ? botonEditarObservacionDetalleComentario(detalle)
                                : botonEditarObservacionDetalleComentario(detalle)">
                              <v-icon small>
                                {{ detalle.comentarios !== '' && detalle.comentarios !== null
                                  ? 'mdi-comment-text-outline'
                                  : 'mdi-comment-plus-outline' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ detalle.comentarios !== '' && detalle.comentarios !== null
                              ? detalle.comentarios
                              : 'Agregar comentario al detalle' }}
                          </span>
                        </v-tooltip>
                      </div>
                    </td>
                    <td>
                      <v-badge
                        :value="detalle.espesificaciones.length > 0"
                        :content="detalle.espesificaciones.length"
                        overlap>
                        <v-btn color="primary" icon @click="handleMostrarEspecificaciones(detalle)">
                          <v-icon>
                            {{ detalle.espesificaciones.length > 0
                              ? 'mdi-folder-file'
                              : 'mdi-folder-plus' }}
                          </v-icon>
                        </v-btn>
                      </v-badge>
                    </td>
                    <td v-if="esAdminAuditora">
                      <ToggleArchivarDetalle
                        :id-detalle="detalle.id"
                        :archivar="detalle.fechaSeguimientoCompleto === null"
                        v-on:success="refrescarRegistros"
                      >
                      </ToggleArchivarDetalle>
                    </td>
                    <td>
                      <v-tooltip v-if="detalle.auditoriaObservacion.auditoriaInforme.dataFile" top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            color="red"
                            @click="verPdf(detalle.auditoriaObservacion.auditoriaInforme)"
                          >
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                        </template>
                        <span>
                          Ver PDF
                        </span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <template v-if="detalle.seguimientos.length > 0">
                            <v-badge :content="detalle.seguimientos.length" overlap>
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="mostrarDetalleSeguimiento(detalle)"
                              >
                                <v-icon>mdi-folder-file-outline</v-icon>
                              </v-btn>
                            </v-badge>
                          </template>
                          <template v-else>
                            <v-btn
                              v-show="!esAdminAuditora"
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="agregarSeguimientoDetalleObservacion(detalle, 1)"
                            >
                              <v-icon>mdi-folder-file-outline</v-icon>
                            </v-btn>
                          </template>
                        </template>
                        <span>Seguimiento ({{ detalle.seguimientos.length }})</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <v-pagination
        v-show="getCantidadPaginas > 1"
        v-model="page"
        :length="getCantidadPaginas"
        :total-visible="5"
      >
      </v-pagination>
    </v-container>
    <v-dialog v-model="mostrarRegistrarSeguimiento" persistent scrollable width="650px">
      <RegistrarObservacionDetalleSeguimiento
        v-if="esteDetalle"
        :detalle="esteDetalle"
        :tipo="tipoSeguimiento"
        v-on:cerrar="cancelarRegistrarRespuesta"
        v-on:success="refrescarRegistros"
      >
      </RegistrarObservacionDetalleSeguimiento>
    </v-dialog>
    <v-dialog v-model="mostrarPdfInforme" persistent scrollable width="750px">
      <v-card>
        <v-card-title>
          Vista previa PDF
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelarVerPdf()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf v-if="esteInforme" :ruta-archivo="esteInforme.dataFile"> </VistaPreviaPdf>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarSeguimientos" persistent width="650px">
      <v-card>
        <v-card-title>
          Archivos de Seguimiento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarMostrarSeguimiento">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <div class="d-flex mb-1 mt-1">
            <v-spacer></v-spacer>
          </div>
          <ListadoDetalleSeguimiento
          v-if="esteDetalle"
          :id-detalle="esteDetalle.id"
          :solo-lectura="esAdminAuditora"
          >
        </ListadoDetalleSeguimiento>
      </v-card-text>
      <v-card-actions>
          <custom-button
            v-show="esAdminAuditora"
            iconText="mdi-plus"
            tipo="agregar"
            block
            @click="agregarSeguimientoDetalleObservacion(esteDetalle, 1)"
          >
            Nuevo
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarArchivosEspecificaciones" persistent width="650px">
      <v-card>
        <v-card-title>
          Especificaciones del Desglose
          <v-spacer></v-spacer>
          <v-btn icon @click="handleCerrarArchivosEspecificaciones">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <ListadoEspesificacions
            v-if="esteDetalle"
            :solo-lectura="true"
            :id-detalle="esteDetalle.id">
          </ListadoEspesificacions>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-navigation-drawer app right temporary :value="esteIdContrato !== null" width="350px">
      <v-card flat>
        <v-card-title>
          Contrato
          <v-spacer></v-spacer>
          <v-btn @click="esteIdContrato = null" icon>
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <contrato-detalles v-if="esteIdContrato" :id-contrato="esteIdContrato">
          </contrato-detalles>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>

    <!-- ACTUALIZAR COMENTARIO DEL DETALLE -->
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarDetalleComentario"
      v-model="mostrarEditarDetalleComentario"
      persistent
      scrollable
      width="800px"
      >
      <EditarDetalleComentario
        v-on:cerrar="mostrarEditarDetalleComentario = !mostrarEditarDetalleComentario"
        :detalle="esteDetalle"
      >
      </EditarDetalleComentario>
    </v-dialog>
    <!-- ACTUALIZAR COMENTARIO DE LA OBSERVACIÓN -->
    <v-dialog
      v-if="!$apollo.loading && mostrarEditarObservacionComentario"
      v-model="mostrarEditarObservacionComentario"
      width="800px"
      persistent
      scrollable
    >
      <EditarObservacionComentario
        v-on:cerrar="mostrarEditarObservacionComentario = !mostrarEditarObservacionComentario"
        :observacionEditar="estaObservacion"
      >
      </EditarObservacionComentario>
    </v-dialog>
  </div>
</template>

<script>
import OBSERVACIONES_DETALLES_ESTADISTICAS from '@/graphql/querys/administracion/auditorias/auditoriasInformesObservacionesDetallesEstadisticas.gql';
import TOGGLE_OBSERVACIONES_DETALLES from '@/graphql/querys/administracion/auditorias/auditoriasInformesObservacionesDetalles.gql';
import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';
import ExcelObservacionesAuditoriasEtiquetas from '@/components/exportar/exceles/ExcelObservacionesAuditoriasEtiquetas.vue';
import EditarObservacionComentario from '@/components/administracion/auditorias/observaciones/EditarComentario.vue';
import EditarDetalleComentario from '@/components/administracion/auditorias/observaciones/detalles/EditarComentario.vue';
import ListadoEspesificacions from '@/components/administracion/auditorias/observaciones/detalles/respuestas/ListadoEspesificaciones.vue';
import RegistrarObservacionDetalleSeguimiento from '../../../../components/administracion/auditorias/observaciones/detalles/respuestas/Nueva.vue';
import TituloBar from '../../../../components/TituloToolBar.vue';
import ToggleArchivarDetalle from '../../../../components/administracion/auditorias/observaciones/detalles/ToggleArchivar.vue';
import ListadoDetalleSeguimiento from '../../../../components/administracion/auditorias/observaciones/detalles/respuestas/Listado.vue';
import ContratoDetalles from '../../../../components/administracion/contratos/ContratoDetalles.vue';
import CustomButton from '../../../../components/buttons/Button.vue';
import VistaPreviaPdf from '../../../../components/administracion/auditorias/informes/verPdf.vue';
import Filtros from './Filtros.vue';

export default {
  name: 'SeguimientoAdutorias',
  components: {
    TituloBar,
    ToggleArchivarDetalle,
    ListadoDetalleSeguimiento,
    ContratoDetalles,
    CustomButton,
    RegistrarObservacionDetalleSeguimiento,
    VistaPreviaPdf,
    Filtros,
    ListadoEspesificacions,
    EditarObservacionComentario,
    EditarDetalleComentario,
    ExcelObservacionesAuditoriasEtiquetas,
  },
  apollo: {
    auditoriasInformesObservacionesDetalles: {
      query: TOGGLE_OBSERVACIONES_DETALLES,
      variables() {
        return {
          filtros: this.filtros,
        };
      },
    },
    auditoriasInformesObservacionesDetallesEstadisticas: {
      query: OBSERVACIONES_DETALLES_ESTADISTICAS,
      variables() {
        return {
          filtros: this.filtros,
        };
      },
    },
    catalogoAuditoriaEtiquetas: {
      query: CATALOGO_AUDITORIA_ETIQUETAS,
    },
  },
  data() {
    return {
      showTags: true,
      mostrarMenuExportar: false,
      headers: [
        {
          id: 'fecha-vencimiento',
          text: 'Fecha Vencimiento',
        },
        {
          id: 'auditoria',
          text: 'Auditoría',
        },
        {
          id: 'informe',
          text: 'Informe',
        },
        {
          id: 'observacion',
          text: 'Observación',
        },
        {
          id: 'accion-documento-pendiente',
          text: 'Acción o Documento Pendiente',
        },
        {
          id: 'especificaciones',
          text: 'Especif.',
        },
        {
          id: 'archivar',
          text: '',
        },
        {
          id: 'acciones',
          text: '',
        },
      ],
      mostrarEditarDetalleComentario: false,
      mostrarEditarObservacionComentario: false,
      estaObservacion: null,
      conSeguimiento: true,
      esteIdContrato: null,
      mostrarPdfInforme: false,
      mostrarRegistrarSeguimiento: false,
      mostrarArchivosEspecificaciones: false,
      mostrarSeguimientos: false,
      esteDetalle: null,
      tipoSeguimiento: 1, // 1: Respuestas, 2: Especificaciones
      esteInforme: null,
      page: 1,
      filtros: {
        ejercicio: new Date().getFullYear(),
        idEnteFiscalizador: null,
        idAuditoria: null,
        idInforme: null,
        fechaVencimiento: null,
        fueEnviada: null,
        estatus: 'sin-seguimiento',
        etiquetas: [],
        limit: 20,
        offset: 0,
      },
    };
  },
  mounted() {
    const queryParams = new URLSearchParams(window.location.search);
    const ejercicio = queryParams.get('ejercicio');
    const idEnteFiscalizador = queryParams.get('idEnteFiscalizador');
    const idAuditoria = queryParams.get('idAuditoria');
    const idInforme = queryParams.get('idInforme');
    const estatus = queryParams.get('estatus');
    const etiquetas = queryParams.get('etiquetas');
    const page = queryParams.get('page') || 1;
    this.page = parseInt(page, 10);
    this.filtros.ejercicio = ejercicio ? parseInt(ejercicio, 10) : new Date().getFullYear();
    this.filtros.idEnteFiscalizador = idEnteFiscalizador === 'null' ? null : idEnteFiscalizador;
    this.filtros.idAuditoria = idAuditoria === 'null' ? null : idAuditoria;
    this.filtros.idInforme = idInforme === 'null' ? null : idInforme;
    this.filtros.estatus = estatus || 'con-seguimiento';
    this.filtros.etiquetas = etiquetas ? etiquetas.split(',').map((id) => parseInt(id, 10)) : [];
    this.filtros.offset = (this.page - 1) * this.filtros.limit;
    this.refrescarRegistros();
  },
  methods: {
    refrescarRegistros() {
      Promise.all([this.refrescarEstadistica(), this.refrescarListado()]);
    },
    async refrescarListado() {
      await this.$apollo.queries.auditoriasInformesObservacionesDetalles.refetch({
        filtros: this.filtros,
      });
    },
    async refrescarEstadistica() {
      await this.$apollo.queries.auditoriasInformesObservacionesDetallesEstadisticas.refetch();
    },
    setFiltroEstatus(estatus) {
      this.refrescarListado();

      this.filtros.estatus = estatus;
    },
    verPdf(informe) {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = informe;
    },
    cancelarVerPdf() {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = null;
    },
    getDiasRestantes(fechaVencimiento) {
      const formatedFechaVencimiento = new Date(`${fechaVencimiento}`);
      const hoy = new Date();
      const diferenciasEnMilisegundos = formatedFechaVencimiento - hoy;

      return Math.floor(diferenciasEnMilisegundos / (1000 * 60 * 60 * 24));
    },
    getColorFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return '#EF5350';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'warning';

      return 'success';
    },
    getIconFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return 'mdi-clock-time-eleven-outline';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'mdi-clock-time-seven-outline';

      return 'mdi-clock-time-two-outline';
    },
    agregarSeguimientoDetalleObservacion(detalle, tipo) {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
      this.esteDetalle = detalle;
      this.tipoSeguimiento = tipo;
    },
    detallesContrato(id) {
      this.esteIdContrato = id;
    },
    mostrarDetalleSeguimiento(idDetalle) {
      this.esteDetalle = idDetalle;
      this.mostrarSeguimientos = !this.mostrarSeguimientos;
    },
    cancelarRegistrarRespuesta() {
      this.mostrarRegistrarSeguimiento = !this.mostrarRegistrarSeguimiento;
    },
    cerrarMostrarSeguimiento() {
      this.esteDetalle = null;
      this.mostrarSeguimientos = false;
    },
    getColorStatus(estatus) {
      switch (estatus) {
        case 'PENDIENTE':
          return 'red darken-1';
        case 'POR RESPONDER':
          return 'orange';
        case 'RESPUESTA ENVIADA PARCIAL':
          return 'info';
        case 'RESPUESTA ENVIADA COMPLETA':
          return 'success';
        case 'SOLVENTADA':
          return 'green darken-1';
        default:
          return 'warning';
      }
    },
    botonEditarObservacionDetalleComentario(detalle) {
      this.esteDetalle = detalle || {};
      if (this.esteDetalle && this.esteDetalle.id) this.mostrarEditarDetalleComentario = true;
    },
    botonEditarObservacionComentario(detalle) {
      this.estaObservacion = detalle.auditoriaObservacion || {};
      if (this.estaObservacion) this.mostrarEditarObservacionComentario = true;
    },
    handleMostrarEspecificaciones(detalle) {
      this.mostrarArchivosEspecificaciones = !this.mostrarArchivosEspecificaciones;
      this.esteDetalle = detalle || {};
    },
    handleCerrarArchivosEspecificaciones() {
      this.mostrarArchivosEspecificaciones = false;
      this.esteDetalle = null;
    },
  },
  computed: {
    getAuditoriaEtiquetas() {
      if (!this.catalogoAuditoriaEtiquetas) return [];
      return this.catalogoAuditoriaEtiquetas;
    },
    esAdminAuditora() {
      if (!this.$auth.user || !this.$auth.user.scopes) return false;
      if (!this.$auth.user.scopes.includes('Auditorías:registro')) return false;
      return true;
    },
    getHeaders() {
      if (this.esAdminAuditora) return this.headers;

      return this.headers.filter(({ id }) => id !== 'archivar');
    },
    getListadoDetalles() {
      if (!this.auditoriasInformesObservacionesDetalles.data) return [];
      return this.auditoriasInformesObservacionesDetalles.data;
    },
    getCantidadResultadosEncontrados() {
      if (!this.auditoriasInformesObservacionesDetalles) return 0;
      return this.auditoriasInformesObservacionesDetalles?.numeroResultados;
    },
    getCantidadPaginas() {
      if (
        this.getCantidadResultadosEncontrados === 0
        || this.getCantidadResultadosEncontrados === this.filtros.estatus.limit
      ) return 0;
      return Math.ceil(this.getCantidadResultadosEncontrados / this.filtros.limit);
    },
    getEstadistica() {
      if (!this.auditoriasInformesObservacionesDetallesEstadisticas) return {};

      return this.auditoriasInformesObservacionesDetallesEstadisticas;
    },
    getCantidadConSeguimiento() {
      if (!this.auditoriasInformesObservacionesDetallesEstadisticas) return '0';
      return String(
        this.auditoriasInformesObservacionesDetallesEstadisticas.cantidadConSeguimiento,
      );
    },
    getCantidadSinSeguimiento() {
      if (!this.auditoriasInformesObservacionesDetallesEstadisticas) return '0';
      return String(
        this.auditoriasInformesObservacionesDetallesEstadisticas.cantidadSinSeguimiento,
      );
    },
    getCantidadArchivados() {
      if (!this.auditoriasInformesObservacionesDetallesEstadisticas) return '0';
      return String(this.auditoriasInformesObservacionesDetallesEstadisticas.cantidadArchivados);
    },
    getDetallesPorEtiqueta() {
      const etiquetas = [...this.getAuditoriaEtiquetas];
      const etiquetasConDetalles = etiquetas.map((etiqueta) => {
        const detalles = this.getListadoDetalles.filter((detalle) => detalle.etiquetas.find(
          (etiquetaDetalle) => etiquetaDetalle.idAuditoriaEtiqueta === etiqueta.id,
        ));
        return {
          ...etiqueta,
          detalles,
        };
      })
        .filter((etiqueta) => etiqueta.detalles.length > 0);
      return etiquetasConDetalles;
    },
  },
  watch: {
    page: {
      handler(page) {
        this.filtros.offset = (page - 1) * this.filtros.limit;
        this.refrescarListado();
      },
    },
    filtros: {
      handler(filtros) {
        const filtross = { ...filtros, page: this.page };

        const url = new URL(window.location.href);

        Object.keys(filtross).forEach((key) => {
          const value = filtross[key];
          url.searchParams.set(key, value);
        });

        window.history.pushState({}, '', url.toString());

        this.refrescarListado();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss"></style>
